module.exports = __webpack_public_path__ + "img/BGVoided.c8a727f5.png";